import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
// import Swiper core and required modules
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { EffectFade, Navigation, Pagination } from "swiper";
import axios from "axios";
const scrollTop = () => { window.scrollTo({ top: 0, behavior: "smooth" }) }
// install Swiper modules
SwiperCore.use([Navigation, Pagination, EffectFade]);

// Log the API token to the console to confirm its value
// console.log("API_TOKEN:", API_TOKEN);

function ShowCollection(props) {

  // API configuration constants
  const API_URL = "https://test.campfr.com/api/list_collection/" + props.cid;
  // const API_URL = "http://localhost:8000/api/list_featured_workshops/";
  const API_TOKEN = process.env.REACT_APP_API_TOKEN;

  const slctSlider = {
    slidesPerView: 1,
    speed: 1000,
    spaceBetween: 20,
    loop: true,
    roundLengths: true,
    autoplay: {
      delay: 15000
    },
    navigation: {
      nextEl: `.testi-next4-${props.cid}`,
      prevEl: `.testi-prev4-${props.cid}`,
    },
    breakpoints: {
      480: {
        slidesPerView: 1
      },
      576: {
        slidesPerView: 2
      },
      992: {
        slidesPerView: 2
      },
      1200: {
        slidesPerView: 3
      },
      1400: {
        slidesPerView: 3
      },

    }
  }


  // Define a color mapping for the 10 artforms.
  const artformColors = {
    music: "#367591",
    sound: "#009FE3",
    film: "#FBF299",
    art: "#E6007E",
    environment: "#6EBC86",
    writing: "#7B6A58",
    activism: "#E24259",
    performance: "#725283",
    video: "#ABD194",
    vr: "#4D4C4C"
  };

  // State management for data, loading status, and error handling
  const [collection, setCollection] = useState([]);
  const [collectionTitle, setCollectionTitle] = useState([]);
  const [collectionDesc, setCollectionDesc] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    /**
     * Fetches data from the API with authentication token
     */

    const fetchData = async () => {
      try {
        const response = await axios.get(API_URL, {
          headers: { "X-API-TOKEN": API_TOKEN }
        });

        console.log("API Response:", response.data);

        const data = response.data; // Use the response data directly
        setCollection(data.workshops);
        setCollectionTitle(data.title);
        setCollectionDesc(data.short_description);

        setLoading(false);
      } catch (error) {
        console.error("API Error:", error);
        setError(error.message || "Failed to fetch API");
        setLoading(false);
      }
    };

    fetchData();
  }, []); // Empty dependency array means this effect runs once on mount

  console.log(error);

  let kc = 0;
  let k = '';

  // Map over the fetched workshops to render slides
  const listItems = collection.map((workshop, index) => {

    k = 'coll_card_' + props.cid + '_' + kc;

    // Convert the comma-separated artforms string into an array
    const artformTags = workshop.artforms.split(',').map((art, idx) => {
      const trimmedArt = art.trim();
      return (
        <span
          key={idx}
          style={{
            backgroundColor: artformColors[trimmedArt],
            color: "white",
            borderRadius: "8px",
            padding: "4px 8px",
            fontSize: "0.9rem",
            marginRight: "4px",
            marginBottom: "4px"
          }}
        >
          {trimmedArt}
        </span>
      );
    });

    // Array of tutor color classes corresponding to: #00ffff, #ff00ff, #ffff00.
    // Ensure these classes are defined in your CSS.
    const tutorColorClasses = ['txt-gradient-1', 'txt-gradient-2', 'txt-gradient-3', 'txt-gradient-4', 'txt-gradient-5', 'txt-gradient-6'];
    const randomTutorClass = tutorColorClasses[Math.floor(Math.random() * tutorColorClasses.length)];

    return (


      <SwiperSlide className="swiper-slide">
        <PackageCardBeta image={workshop.course_image} date={workshop.date} duration={workshop.duration} ctype={workshop.ctype} title={workshop.title_with} tutors={workshop.tutors} tutorclass={randomTutorClass} places={workshop.places} placesword={workshop.placesword} artforms={artformTags} key={workshop.id} wslink={workshop.ctype + "/" + workshop.short_url} />
      </SwiperSlide>


    );

    kc++;

  });

  return (
    <>
      <div className={`upcoming-tour-area upcoming-tour-area-${props.cid} pt-110 pb-110 chain`}>
        <div className="container">
          <div className="row d-flex justify-content-center align-items-center">
            <div className="col-lg-5 d-flex justify-content-lg-start justify-content-center">
              <div className="section-head-alpha text-lg-start text-center">
                <h2 className="text-white">{collectionTitle}</h2>
                <p className="text-white">{collectionDesc}</p>
              </div>
            </div>


            <div className="col-lg-7 d-flex justify-content-lg-end justify-content-center">
              <div className={`slider-arrows text-center d-lg-flex flex-row justify-content-center d-none gap-5 slider-arrows-${props.cid}`}>
                <div className={`testi-prev4 testi-prev4-${props.cid}`} tabIndex={0} role="button" aria-label="Previous slide">
                  <i className="bi bi-arrow-left" />
                </div>
                <div className={`testi-next4 testi-next4-${props.cid}`} tabIndex={0} role="button" aria-label="Next slide">
                  <i className="bi bi-arrow-right" />
                </div>
              </div>
            </div>


          </div>
          <div className="row align-items-center justify-content-center fadeffect">
            <div className="col-lg-12">
              <Swiper className="swiper upcoming-tour" {...slctSlider}>
                <div className="swiper-wrapper">

                  {listItems}

                </div>
              </Swiper>
            </div>
          </div>
          <div className="row text-center d-flex justify-content-center">
            <div className="col-md-4">
              <a href="/collection/{props.cid}" className="button-outlined-primary upcoming-btn mt-50">View collection</a>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
function PackageCardBeta(props) {

  return (
    <>
      <div className="package-card-beta">
        <div className="package-thumb">
          <Link to={`${process.env.PUBLIC_URL}${props.wslink}`} onClick={scrollTop}><img src={`${process.env.PUBLIC_URL} ${props.image}`} alt="" /></Link>
          <div className="artformcontainer">{props.artforms}</div>
          <p className="card-lavel">
            <i className="bi bi-clock" /> <span className="card-lavel-t1">{props.date}</span> / <span className="card-lavel-t1">{props.duration}</span> / <span className={`card-lavel-t3-${props.ctype}`}>{props.ctype}</span>
          </p>
        </div>
        <div className="package-card-body">
          <h3 className="p-card-title"><Link to={`${process.env.PUBLIC_URL}${props.wslink}`} onClick={scrollTop}>{props.title} <span className={props.tutorclass}>{props.tutors}</span></Link></h3>
          <div className="p-card-bottom">
            <div className="book-btn">
              <Link to={`${process.env.PUBLIC_URL}${props.wslink}`} onClick={scrollTop}>Book Now <i className="bx bxs-right-arrow-alt" /></Link>
            </div>
            <div className="p-card-info">
              <h6>{props.places} <span>{props.placesword}</span></h6>
            </div>
          </div>
        </div>
      </div>
    </>
  )

}


export default ShowCollection